module.exports = __webpack_public_path__ + "img/edit-approved.84046472.svg";